export function formatNumberToNumber(
  numberInput: number | undefined | null | string,
): number {
  if (typeof numberInput === 'string') {
    return Number(numberInput.replace(/\u00A0/g, '').replace(/\s/g, ''));
  } else if (numberInput === undefined || numberInput === null) {
    return 0;
  }

  return Number(numberInput);
}
